import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, X } from "lucide-react";
import { api, coverUrl } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function NewsBanner() {
  const { user } = useAuth();
  const [news, setNews] = useState(null);

  useEffect(() => {
    if (!user) { setNews(null); return; }
    api.get("/me/news").then((r) => setNews(r.data)).catch(() => setNews(null));
  }, [user]);

  const dismiss = async () => {
    setNews(null);
    try { await api.post("/me/news/seen"); } catch {}
  };

  if (!news || (!news.packs?.length && !news.new_tracks)) return null;
  const packs = news.packs || [];
  const parts = [];
  if (packs.length) parts.push(`${packs.length} pack${packs.length === 1 ? "" : "s"} nuevo${packs.length === 1 ? "" : "s"}`);
  if (news.new_tracks) parts.push(`${news.new_tracks} track${news.new_tracks === 1 ? "" : "s"} nuevo${news.new_tracks === 1 ? "" : "s"}`);

  return (
    <div className="border-b border-red-900/40 bg-red-950/20 backdrop-blur-sm" data-testid="news-banner">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-2.5 flex items-center gap-3 flex-wrap">
        <Sparkles className="w-4 h-4 text-red-500 shrink-0" />
        <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-red-400 shrink-0">Novedades desde tu última visita</span>
        <span className="text-sm text-white/80" data-testid="news-banner-summary">{parts.join(" · ")}</span>
        <div className="flex items-center gap-2 flex-wrap">
          {packs.slice(0, 3).map((p) => (
            <Link key={p.id} to={`/pack/${p.id}`} onClick={dismiss} data-testid={`news-pack-${p.id}`}
              className="flex items-center gap-2 pl-1 pr-3 py-1 rounded-full border border-white/10 bg-black/40 hover:border-red-600/60 transition-colors">
              <span className="w-6 h-6 rounded-full overflow-hidden bg-neutral-900 shrink-0">{p.cover_path && <img src={coverUrl(p.cover_path, 160)} alt="" className="w-full h-full object-cover" />}</span>
              <span className="text-xs text-white/85 truncate max-w-[180px]">{p.title}</span>
            </Link>
          ))}
          {news.new_tracks > 0 && <Link to="/pool" onClick={dismiss} data-testid="news-tracks-link" className="text-xs text-red-400 hover:text-white underline underline-offset-2">Ver tracks nuevos</Link>}
        </div>
        <span className="flex-1" />
        <button type="button" onClick={dismiss} data-testid="news-banner-dismiss" className="text-white/40 hover:text-white p-1 rounded" title="Entendido">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
